import React from 'react'
import { motion } from "framer-motion";
import { pageload } from "../motion-varients/pageload";

export default function AnimatedPage({ children }) {
    return (
        <motion.div
            initial="unmounted"
            animate="mounted"
            variants={pageload}
        >
            {children}
        </motion.div>
    )
}
